// src/utils/isEmpty.ts
function e(e) {
	if (e == null) return !0;
	if (typeof e == "string" || Array.isArray(e)) return e.length === 0;
	if (e instanceof Map || e instanceof Set) return e.size === 0;
	if (typeof e == "object") {
		for (let t in e) if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
		return !0;
	}
	return !0;
}
export { e as default, e as isEmpty };

//# sourceMappingURL=isEmpty.js.map